<template>
    <div class="scroll-list">
        <div class="v-scroll-list">
            <div ref="outter" class="v-scroll-list__outter" @scroll="handleScroll">
                <ul class="v-scroll-list__inner" :style="optimized ? innerStyle : ''">
                    <li
                        v-for="(item, index) in displayOptions"
                        :key="index"
                        :class="{ deactive: item.type === 'loadMore' }"
                        class="v-scroll-list__item"
                    >
                        <slot name="item" :item="item"></slot>
                    </li>
                    <li v-if="inPageLoading" class="page-loading">
                        <img src="//bqq.gtimg.com/qidian/src/themes/blue/common/images/loading.gif" alt />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
  import { throttledebounce } from '@/common/contact-selector/utils/index'

  export default {
    name: 'ScrollList',
    props: {
      options: {
        type: Array,
        default: () => {
          return [];
        }
      },
      // 默认定位到的index
      start: {
        type: Number,
        default: 0
      },
      itemSize: {
        type: Number,
        default: 36
      },
      // 超过max数目后开启优化模式
      max: {
        type: Number,
        default: 50
      },
      threshold: {
        type: Number,
        default: 0
      },
      calcOverflowWidth: {
        type: Boolean,
        default: false
      },
      addListKeepBottom: {
        type: Boolean,
        default: false
      },
      pageInfo: {  // 为啥pageInfo要从外侧传进来？因为srv分页接口太混乱，可能存在不同规则
        type: Object,
        default(){
          return {}
        }
      },
      // 分页加载的时候展示进度条
      inPageLoading: {
          type: Boolean,
          default: false
      }
    },
    data() {
      let total = this.options.length;
      return {
        outterSize: 0, // outtersize
        lastScrollTop: 0, // 用来判断scroll的方向
        prevScrollTop: 0,
        currentStart: this.start < total && this.start > 0 ? this.start : 0,
        inited: false,
        calcing: false,
        lastScroll:0
        // pager: pageInfo,
        // pageIndex: 0
      };
    },
    mounted() {
      // 初始化滚动位置
      this.updateOutterSize();

      if (this.total) {
        this.init();
      }
    },
    watch: {
      options(arr, oldArr) {
        if (oldArr.length === 0 && arr.length) {
          this.currentStart = this.start < arr.length ? this.start : 0;
          this.$nextTick(() => {
            this.init();
          });
        }
        this.update();
        if (this.addListKeepBottom && arr.length > oldArr.length) {
          this.$nextTick(() => {
            const $outter = this.$refs.outter
            $outter.scrollTop = $outter.scrollHeight
          })
        }
      }
    },
    computed: {
      // 是否开启优化模式
      optimized() {
        return this.max < this.total;
      },
      total() {
        return this.options.length;
      },
      displayOptions() {
        let list = this.optimized
          ? this.currentStart + this.max > this.total
            ? this.options.slice(this.total - this.max, this.total)
            : this.options.slice(this.currentStart, this.currentStart + this.max)
          : this.options;
        list.length && this.$emit('discover', list)
        return list;
      },
      innerStyle() {
        return {
          'padding-top': this.calcSize(0, this.currentStart) + 'px',
          'padding-bottom': this.calcSize(this.max + this.currentStart, this.total) + 'px'
        };
      },
      calcThreshold() {
        return this.threshold || (this.itemSize * 10);
      }
    },
    methods: {
      updateOutterSize() {
        this.outterSize = this.$refs.outter && this.$refs.outter.clientHeight;
      },
      /**
       * 计算两个数据项展示区域顶部之间的间距（像素）
       * @param {number} start 开始项的索引
       * @param {number} end 结束项的索引
       * @return {number} 两个项的顶部之间的间距
       */
      calcSize(start, end) {
        if (start < 0 || end <= start || this.total < end) {
          return 0;
        }

        return (end - start) * this.itemSize;
      },
      /**
       * 初始化
       */
      init() {
        if (this.outtersize === 0) {
          // 没有计算出outter的高度，说明当前是被隐藏的
          // 此时不需要计算高度了和定位默认位置了
          return;
        }

        if (!this.itemSize) {
          // itemSize 是0，则自动使用第一个项的高度为itemSize
          let firstItem = this.$el.querySelector('.v-scroll-list__item');
          this.itemSize = firstItem && firstItem.offsetHeight || 0;
        }

        if (this.inited) {
          // 如果已经初始化了，则更新
          this.update();
          return;
        }
        this.inited = true;
      },
      setOverflowWidth () {
        if (this.calcing) return
        this.calcing = true
        setTimeout(() => {
          let max = 0
          this.$refs.outter.querySelectorAll('.select-tree-item').forEach(item => {
            const width = parseInt(item.style.paddingLeft) + 60 + item.querySelector('.select-item-name').offsetWidth
            max = max > width ? max : width
          })
          const outerWidth = this.$refs.outter.offsetWidth
          this.$refs.outter.querySelector('.v-scroll-list__inner').style.width = (max > outerWidth ? max : '')  + 'px'
          this.calcing = false
        }, 100)
      },
      /**
       * 计算新的currentStart以及更新其他数据，一般在滚动之后调用
       */
      update() {
        if (!this.optimized) {
          return;
        }
        let start = this.currentStart;
        const scrollTop = this.$refs.outter.scrollTop;
        if (scrollTop === this.lastScrollTop) {
          return;
        }
        const visualEnd = scrollTop + this.outterSize;
        const bottomOffset = this.calcSize(0, start + this.max) - visualEnd;
        const topOffset = scrollTop - this.calcSize(0, start);
        // 是否向下滚动
        const down = scrollTop > this.lastScrollTop;

        const ignore = (down ? bottomOffset : topOffset) > this.calcThreshold;
        if (ignore) {
          // 没有超过阀值
          this.lastScrollTop = scrollTop;
          return;
        }

        // 每项的高度相同时，直接通过除法就能计算出结果
        if (!this.itemSize) {
          // currentItemSize 为 0
          this.lastScrollTop = scrollTop;
          return;
        }

        start = down
          ? start + Math.floor(topOffset / this.itemSize)
          : start - Math.floor(bottomOffset / this.itemSize);

        // https://jsperf.com/math-max-vs-for/3
        this.currentStart = start < 0 ? 0 : (start > this.total - this.max ? this.total - this.max : start);
        this.lastScrollTop = scrollTop
      },
      handleScroll: throttledebounce(function (event) {
        this.update()
        let {scrollTop,scrollHeight,offsetHeight} = event.target
        if(scrollTop + offsetHeight > scrollHeight - 10 && this.lastScroll < scrollTop ){
          this.$emit("pageMore", this.pageInfo )
          // console.log("xxxxxxxxxx", scrollTop, scrollHeight, event.target )
        }
        this.lastScroll = scrollTop
      }, 250)
    },
    activated () {
      this.$nextTick(() => {
        this.$refs.outter.scrollTop = this.prevScrollTop
      })
    },
    deactivated () {
      this.prevScrollTop = this.lastScrollTop
    }
  };
</script>

<style lang="less">
.scroll-list {
    height: 100%;

    .v-scroll-list {
        position: relative;
        overflow-x: hidden;
        height: 100%;
        background-color: #fff;
        // margin-right: 20px;

        .v-scroll-list__outter {
            position: absolute;
            top: 0;
            left: 0;
            overflow-x: hidden;
            overflow-y: auto;
            width: 100%;
            height: 100%;

            // .v-scroll-list__inner{
            //   width: fit-content;
            //   min-width: 100%;
            // }
        }
    }
}
</style>
